import React from 'react';
import classnames from 'classnames';
import useScreen from 'hooks/useScreen';
import { LEATHER_PRODUCT_OPTION_ID } from 'commons/constants';
import { decideLaterItem } from 'components/consumer/PDP/PDPShopTabsBar/itemContent';
import usePDPOptions from 'components/consumer/PDP/state/context/usePDPOptions';

const DECIDE_LATER_TEXT =
  'Need a little extra time to decide? No worries, simply add your item to your cart with the “Buy Now, Decide Later” option selected. We’ll send you a free swatch kit with all of our upholstery options. Make your selection within 90 days by logging into your account and updating your order or reach out to customer service! Please note, if a fabric has not been chosen after 90 days, your order will be canceled and subject to a 10% cancellation fee.';
// CON-8008: no swatch kit is sent for leather Decide Later purchases
const DECIDE_LATER_LEATHER_TEXT =
  'Need a little extra time to decide? No worries, simply add your item to your cart with the “Buy Now, Decide Later” option selected. Make your selection within 90 days by logging into your account and updating your order or reach out to customer service! Please note, if a fabric has not been chosen after 90 days, your order will be canceled and subject to a 10% cancellation fee.';
const PDPSelectUpholsteryDecideLater = () => {
  const { isMobile } = useScreen();
  const { data: { upholsteryOptionId } = {} } = usePDPOptions();
  const isLeather = upholsteryOptionId === LEATHER_PRODUCT_OPTION_ID;

  return (
    <div className="mt-8 mx-0 mb-12" id={decideLaterItem.contentId}>
      <div className="text-[1.1875rem] tracking-[.0125rem] font-bold leading-[1.75rem] text-gray mb-4">
        Lock in your price now.
        <br />
        Choose your customizations within 90 days.
      </div>

      <div
        className={classnames(
          'text-sm text-gray',
          'PDPSelectUpholsteryDecideLater__content',
          {
            'ml-4': !isMobile,
            'ml-0': isMobile,
          }
        )}
      >
        {isLeather ? DECIDE_LATER_LEATHER_TEXT : DECIDE_LATER_TEXT}
      </div>
    </div>
  );
};

export default PDPSelectUpholsteryDecideLater;
